import { Link } from "react-router-dom";
import { Box, Button, Paper } from "@mui/material";
import externals404PageStyle from "./externals404PageStyle";
import Typography from "@mui/material/Typography";

const Externals404Page = () => {
  return (
    <Box sx={externals404PageStyle.grey}>
      <Paper sx={externals404PageStyle.noAccessBox}>
        <Typography variant={"h3"}>Leider ist auf diese Seite kein Zugriff möglich</Typography>
        <Button component={Link} variant={"text"} to={"/services/extern"}>
          Zurück zur Übersicht
        </Button>
      </Paper>
    </Box>
  );
};

export default Externals404Page;
